// extracted by mini-css-extract-plugin
export default {"aiBGLight":"F31vkboirOf1mKBhsv00","aiText":"XRPktOrDb2AnaPZu46xQ","removeBg":"vumiXWHqWm3UE0S04fzg","replaceOption":"yfdTROBdJeSFowoSbM0U","AIBG":"TWBvKoVhsrbEhWzrhBw4"};